export const onKeyDownNumberOnly = (
  event: React.KeyboardEvent<HTMLInputElement>,
  onSubmit?: () => void
) => {
  if (event.key === "Enter") {
    onSubmit?.();
  } else if (
    /^[\w\d\s\p{P}\p{S}]$/u.test(event.key) && // only prevent default for alphanumeric characters
    !/[0-9]/.test(event.key) // and not numbers
  ) {
    event.preventDefault();
  }
};
